<script>
import Loader from "../../../small_components/Loader.vue";
import GrayText from "../../../small_components/GrayText.vue";
import DefaultBox from "../../../slots/DefaultBox.vue";
import SmallTitle from "../../../small_components/SmallTitle.vue";
import RouterLinkTo from "../../../small_components/RouterLinkTo.vue";
import routes_mixin from "../../../../mixins/routes_mixin";
import DefaultSelect from "../../../small_components/DefaultSelect.vue";
import UsersWholeStatistic from "./UsersWholeStatistic.vue";
import UsersWorkingStatistic from "./UsersWorkingStatistic.vue";
import UsersVacationsStatistic from "./UsersVacationsStatistic.vue";

export default {
  mixins: [routes_mixin],
  name: "SiteStatusStatistic",
  components: {
    UsersVacationsStatistic,
    UsersWorkingStatistic,
    UsersWholeStatistic,
    DefaultSelect,
    RouterLinkTo,
    SmallTitle,
    DefaultBox,
    Loader,
    GrayText
  },
  computed: {
    types() {
      return [
        {
          id: 1,
          title: 'Site status'
        },
        {
          id: 2,
          title: 'Working'
        },
        {
          id: 3,
          title: 'Vacations'
        }
      ]
    },
  },
  data() {
    return {
      loading: false,
      loaded: false,
      statistics: [],
      startDate: null,
      endDate: null,
      rotateClass: false,
      type: '',
      wholeStatisticComponentKey: 0,
      workingComponentKey: 0,
      vacationsComponentKey: 0,
    }
  },
  mounted() {
  },
  methods: {
    changeType(type) {
      this.type = type.title;
    },

    refresh() {
      this.refreshIconStartRotate();
      this.forceRenderWholeStatisticComponentKey();
    },

    refreshIconStartRotate() {
      this.rotateClass = true;
    },

    forceRenderWholeStatisticComponentKey() {
      this.wholeStatisticComponentKey += 1;
    },

    forceRenderWorkingComponentKey() {
      this.workingComponentKey += 1;
    },

    forceRenderVacationsComponentKey() {
      this.vacationsComponentKey += 1;
    }
  }
}
</script>

<template>
  <div class="row">
    <div class="col-md-12 col-12 mt-20">
      <default-box>
        <div class="d-flex justify-content-between align-items-center">
          <div class="col-md-3">
            <small-title
                class="flex-grow-1"
                no_margin
                :text="$t('dashboard.site_statistic')"/>
          </div>
          <template>
            <div class="row flex-column col-md-3">
              <label class="d-flex justify-content-between align-items-center">
                <span title="Manager" class="default-input__label">
                  {{ $t('inputs.start_date') }}
                </span>
                <input type="date" class=""
                       v-model="startDate">
              </label>
              <label class="d-flex justify-content-between align-items-center mt-10">
                <span title="Manager" class="default-input__label">
                  {{ $t('inputs.end_date') }}
                </span>
                <input type="date" class=""
                       v-model="endDate">
              </label>
            </div>
          </template>
          <template>
            <div class="col-md-3">
              <default-select
                  v-if="startDate && endDate"
                  :placeholder="$t('inputs.select_type')"
                  display_item_api_key="title"
                  :selected_val="type"
                  @change="changeType"
                  :list_outer="types"
              />
              <span v-else>{{ $t('dashboard.select_dates') }}</span>
            </div>
          </template>
          <template>
            <div @click="refresh"  class="d-flex justify-content-end align-items-center col-md-3">
              <svg id="rotate" class="cursor_pointer" :class="{rotate_refresh_icon: rotateClass}" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30" height="30" viewBox="0 0 80 80">
                <path fill="#8bb7f0" d="M7.207,71.5l5.659-5.659l-0.328-0.354C6.064,58.534,2.5,49.482,2.5,40C2.5,19.322,19.322,2.5,40,2.5 c1.696,0,3.499,0.146,5.5,0.448v9.098C43.659,11.684,41.812,11.5,40,11.5c-15.715,0-28.5,12.785-28.5,28.5 c0,7.031,2.628,13.803,7.399,19.066l0.353,0.389l6.248-6.249V71.5H7.207z"></path><path fill="#4e7ab5" d="M40,3c1.55,0,3.193,0.125,5,0.38v8.064C43.325,11.149,41.649,11,40,11c-15.991,0-29,13.009-29,29 c0,7.156,2.674,14.047,7.529,19.402l0.705,0.778l0.743-0.743L25,54.414V71H8.414l4.464-4.464l0.682-0.682l-0.657-0.706 C6.517,58.285,3,49.355,3,40C3,19.598,19.598,3,40,3 M40,2C19.013,2,2,19.013,2,40c0,9.987,3.867,19.055,10.172,25.828L6,72h20V52 l-6.73,6.73C14.773,53.771,12,47.224,12,40c0-15.464,12.536-28,28-28c2.062,0,4.065,0.238,6,0.661V2.519 C44.041,2.207,42.047,2,40,2L40,2z"></path><g><path fill="#8bb7f0" d="M40,77.5c-1.696,0-3.499-0.146-5.5-0.448v-9.098c1.841,0.362,3.687,0.546,5.5,0.546 c15.715,0,28.5-12.785,28.5-28.5c0-7.043-2.625-13.817-7.391-19.075l-0.353-0.389L54.5,26.793V8.5h18.293l-5.676,5.675l0.328,0.354 C73.93,21.495,77.5,30.541,77.5,40C77.5,60.678,60.678,77.5,40,77.5z"></path><path fill="#4e7ab5" d="M71.586,9l-4.481,4.481l-0.682,0.682l0.657,0.706C73.477,21.743,77,30.668,77,40 c0,20.402-16.598,37-37,37c-1.55,0-3.193-0.125-5-0.38v-8.064C36.675,68.851,38.351,69,40,69c15.991,0,29-13.009,29-29 c0-7.168-2.671-14.061-7.52-19.411l-0.705-0.778l-0.743,0.743L55,25.586V9H71.586 M74,8H54v20l6.739-6.739 C65.235,26.221,68,32.776,68,40c0,15.464-12.536,28-28,28c-2.062,0-4.065-0.238-6-0.661v10.142C35.959,77.793,37.953,78,40,78 c20.987,0,38-17.013,38-38c0-9.987-3.884-19.038-10.188-25.812L74,8L74,8z"></path></g>
              </svg>
            </div>
          </template>
        </div>
        <hr/>
        <div class="">
          <template v-if="type === 'Site status'">
            <users-whole-statistic :key="wholeStatisticComponentKey" :start="startDate" :end="endDate"/>
          </template>
          <template v-if="type === 'Working'">
            <users-working-statistic :key="wholeStatisticComponentKey" :start="startDate" :end="endDate"/>
          </template>
          <template v-if="type === 'Vacations'">
            <users-vacations-statistic :key="wholeStatisticComponentKey" :start="startDate" :end="endDate"/>
          </template>
        </div>
      </default-box>
    </div>
  </div>
</template>

<style >
  .rotate_refresh_icon {
    transform: rotate(360deg);
    transition: transform 1s linear;
  }
</style>